<template>
  <span>
    <v-icon v-if="item.codeWorking === false" large color="red" @click="handleClick">mdi-alert</v-icon>
    <v-btn
        v-else-if="item.codeWorking && item.systemScore !== undefined"
        class="d-flex flex-column justify-center"
        icon
        @click="handleClick">
      <health-score-icon :satisfaction-level="item.systemScore" />
    </v-btn>
    <span v-else>N/A</span>
  </span>
</template>

<script>
import HealthScoreIcon from "@/components/HealthScore/CustomerOverview/HealthScoreIcon.vue";

export default {
  name: "ClientHealthScoreIcon",
  components: {HealthScoreIcon},
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    handleClick() {
      this.$emit('click');
    }
  },
}
</script>

<style scoped>

</style>